module.exports = __webpack_public_path__ + "936b572535a87c02ef2a12e7ae730514.pdf";